var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-header"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('button',{on:{"click":_vm.closeModal}},[_c('span',{staticClass:"ti-close"})])]),_c('div',{ref:"modalBody",staticClass:"modal-body"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }